const splashEl = document.getElementById('js-splash')

function checkSplashDisabled() {
  const doDisable = window.location.search.includes('?splash=disable')
  const alreadyDisabled = localStorage.getItem('splashDisabled') == 'true'

  if (doDisable && !alreadyDisabled) {
    localStorage.setItem('splashDisabled', 'true')
    window.location.reload()
  } else {
    document.body.style.overflow = 'hidden'
  }

  if (alreadyDisabled) {
    splashEl.remove()
    document.body.style.overflow = ''
  }
}

if (splashEl) {
  checkSplashDisabled()
}
